var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPpsLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 278.68 63.34",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#231f20;}.cls-2{fill:#ef3c31;}.cls-3{fill:#0081c6;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.23,19.1h5.08c3,0,4.76,1.76,4.76,4.3v0c0,2.88-2.24,4.38-5,4.38H94v3.73H91.23Zm4.9,6.27a1.93,1.93,0,0,0,2.17-1.88v0c0-1.22-.85-1.88-2.22-1.88H94v3.8Z",
    transform: "translate(-4.72 -12.62)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.94,19h2.53l5.33,12.53h-2.86l-1.14-2.79h-5.26l-1.14,2.79h-2.79Zm2.88,7.32-1.65-4-1.65,4Z",
    transform: "translate(-4.72 -12.62)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M115.56,19.1h5.69a4.92,4.92,0,0,1,3.62,1.26,3.87,3.87,0,0,1,1.07,2.84v0a3.86,3.86,0,0,1-2.67,3.86l3,4.44h-3.2l-2.66-4H118.3v4h-2.74Zm5.51,6c1.33,0,2.1-.71,2.1-1.76v0c0-1.18-.82-1.78-2.15-1.78H118.3v3.57Z",
    transform: "translate(-4.72 -12.62)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M131.15,21.62h-3.79V19.1h10.31v2.52h-3.78v9.92h-2.74Z",
    transform: "translate(-4.72 -12.62)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.61,19.1h2.52L148,26.76V19.1h2.7V31.54h-2.33l-6-7.91v7.91h-2.7Z",
    transform: "translate(-4.72 -12.62)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M153.49,19.1h9.38v2.43h-6.66v2.53h5.87v2.43h-5.87V29.1H163v2.44h-9.47Z",
    transform: "translate(-4.72 -12.62)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.24,19.1h5.69a4.92,4.92,0,0,1,3.62,1.26,3.87,3.87,0,0,1,1.07,2.84v0A3.87,3.87,0,0,1,173,27.1l3,4.44h-3.2l-2.66-4H168v4h-2.74Zm5.51,6c1.33,0,2.1-.71,2.1-1.76v0c0-1.18-.82-1.78-2.15-1.78H168v3.57Z",
    transform: "translate(-4.72 -12.62)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.08,29.73l1.61-1.94a5.75,5.75,0,0,0,3.72,1.51c1.12,0,1.79-.44,1.79-1.17v0c0-.69-.42-1.05-2.5-1.58-2.51-.64-4.13-1.33-4.13-3.8v0c0-2.26,1.82-3.75,4.36-3.75a7.22,7.22,0,0,1,4.62,1.58l-1.42,2.06a5.86,5.86,0,0,0-3.24-1.22c-1,0-1.6.48-1.6,1.08v0c0,.81.54,1.08,2.69,1.63,2.52.66,3.94,1.57,3.94,3.73v0c0,2.47-1.88,3.86-4.56,3.86A7.92,7.92,0,0,1,177.08,29.73Z",
    transform: "translate(-4.72 -12.62)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.13,19.1h2.74V24h5V19.1h2.74V31.54h-2.74v-5h-5v5h-2.74Z",
    transform: "translate(-4.72 -12.62)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M202.6,19.1h2.74V31.54H202.6Z",
    transform: "translate(-4.72 -12.62)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M208.29,19.1h5.08c3,0,4.76,1.76,4.76,4.3v0c0,2.88-2.23,4.38-5,4.38H211v3.73h-2.74Zm4.9,6.27a1.93,1.93,0,0,0,2.17-1.88v0c0-1.22-.85-1.88-2.22-1.88H211v3.8Z",
    transform: "translate(-4.72 -12.62)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.23,38.22h8.94v1.3H92.63V44h6.74v1.28H92.63v5.42h-1.4Z",
    transform: "translate(-4.72 -12.62)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M101.91,44.48v0a6.35,6.35,0,1,1,12.69,0v0a6.31,6.31,0,0,1-6.36,6.44A6.25,6.25,0,0,1,101.91,44.48Zm11.23,0v0a4.94,4.94,0,0,0-4.9-5.13,4.88,4.88,0,0,0-4.87,5.1v0a5,5,0,0,0,4.9,5.14A4.89,4.89,0,0,0,113.14,44.48Z",
    transform: "translate(-4.72 -12.62)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.41,38.22h5.35a4.93,4.93,0,0,1,3.54,1.25,3.44,3.44,0,0,1,1,2.45v0c0,2.06-1.43,3.27-3.38,3.62l3.82,5.08H126l-3.6-4.83h-3.56v4.83h-1.4Zm5.22,6.35c1.87,0,3.2-1,3.2-2.56v0c0-1.53-1.17-2.45-3.18-2.45h-3.84v5Z",
    transform: "translate(-4.72 -12.62)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M136.19,38.22h4.66c2.81,0,4.66,1.5,4.66,4v0c0,2.69-2.24,4.07-4.89,4.07h-3v4.39h-1.41ZM140.67,45c2.06,0,3.41-1.1,3.41-2.73v0c0-1.78-1.33-2.7-3.34-2.7H137.6V45Z",
    transform: "translate(-4.72 -12.62)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M147.71,45.46V38.22h1.41v7.15c0,2.68,1.44,4.19,3.8,4.19s3.75-1.38,3.75-4.1V38.22h1.4v7.13c0,3.63-2.08,5.51-5.19,5.51S147.71,49,147.71,45.46Z",
    transform: "translate(-4.72 -12.62)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M161.24,38.22h5.29a4.55,4.55,0,0,1,3.26,1.11,2.78,2.78,0,0,1,.8,2v0a3,3,0,0,1-2,2.88c1.48.44,2.67,1.3,2.67,3v0c0,2.13-1.8,3.39-4.52,3.39h-5.52Zm7.92,3.29c0-1.22-1-2-2.75-2h-3.79v4.29h3.68c1.69,0,2.86-.77,2.86-2.22ZM166.55,45h-3.93V49.4h4.18c1.88,0,3.06-.83,3.06-2.22v0C169.86,45.79,168.72,45,166.55,45Z",
    transform: "translate(-4.72 -12.62)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M173.91,38.22h1.4V49.37h7v1.29h-8.41Z",
    transform: "translate(-4.72 -12.62)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M184.88,38.22h1.4V50.66h-1.4Z",
    transform: "translate(-4.72 -12.62)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M189.21,44.48v0A6.26,6.26,0,0,1,195.5,38a6.51,6.51,0,0,1,4.86,2l-1,1a5.42,5.42,0,0,0-3.91-1.7,4.88,4.88,0,0,0-4.82,5.1v0a4.91,4.91,0,0,0,4.82,5.14,5.39,5.39,0,0,0,4-1.8l.93.91a6.47,6.47,0,0,1-5,2.19A6.21,6.21,0,0,1,189.21,44.48Z",
    transform: "translate(-4.72 -12.62)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M207.08,48.85l.87-1a5.94,5.94,0,0,0,4.26,1.76c1.67,0,2.78-.89,2.78-2.11v0c0-1.16-.63-1.81-3.24-2.36-2.86-.63-4.18-1.55-4.18-3.59v0c0-2,1.73-3.39,4.09-3.39A6.48,6.48,0,0,1,216,39.57l-.81,1.09a5.48,5.48,0,0,0-3.59-1.35c-1.62,0-2.65.89-2.65,2v0c0,1.17.64,1.83,3.38,2.42s4,1.62,4,3.52v0c0,2.14-1.78,3.52-4.25,3.52A7.28,7.28,0,0,1,207.08,48.85Z",
    transform: "translate(-4.72 -12.62)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M219.11,38.22h9V39.5h-7.59v4.25h6.79V45h-6.79v4.35h7.68v1.28h-9.08Z",
    transform: "translate(-4.72 -12.62)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.84,38.22h5.35a4.92,4.92,0,0,1,3.54,1.25,3.44,3.44,0,0,1,1,2.45v0c0,2.06-1.43,3.27-3.38,3.62l3.82,5.08h-1.72l-3.61-4.83h-3.55v4.83h-1.41Zm5.23,6.35c1.86,0,3.19-1,3.19-2.56v0c0-1.53-1.17-2.45-3.18-2.45h-3.83v5Z",
    transform: "translate(-4.72 -12.62)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.11,38.22h1.56l4.43,10.72,4.44-10.72h1.51L248.7,50.75h-1.24Z",
    transform: "translate(-4.72 -12.62)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.47,38.22h1.41V50.66h-1.41Z",
    transform: "translate(-4.72 -12.62)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.81,44.48v0A6.26,6.26,0,0,1,267.1,38,6.47,6.47,0,0,1,272,40l-1,1a5.42,5.42,0,0,0-3.91-1.7,4.88,4.88,0,0,0-4.82,5.1v0a4.91,4.91,0,0,0,4.82,5.14,5.4,5.4,0,0,0,4-1.8l.92.91a6.45,6.45,0,0,1-5,2.19A6.21,6.21,0,0,1,260.81,44.48Z",
    transform: "translate(-4.72 -12.62)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.32,38.22h9V39.5h-7.59v4.25h6.79V45h-6.79v4.35h7.68v1.28h-9.08Z",
    transform: "translate(-4.72 -12.62)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.75,31.11H50.31l.08.08a5.2,5.2,0,0,1,.26,7.13H74.76a1.31,1.31,0,0,0,1.36-1.25v-4.7A1.32,1.32,0,0,0,74.75,31.11Z",
    transform: "translate(-4.72 -12.62)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.18,18.78H37.84L45.13,26H74.19c1.06,0,1.93-.56,1.93-1.26V20C76.1,19.34,75.24,18.78,74.18,18.78Z",
    transform: "translate(-4.72 -12.62)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M74.32,43.52l-28.9-.08-7.17,7.2,36.06.1c1,0,1.8-.56,1.8-1.26v-4.7C76.12,44.09,75.31,43.52,74.32,43.52Z",
    transform: "translate(-4.72 -12.62)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M28.66,56.17l19.61-19.6a2.2,2.2,0,0,0,0-3.1L34.65,19.85l-.91.66c.39,1.2.82,2.5,1.2,3.64L31.79,21.9l-3.14,2.25,1.2-3.64-3.14-2.26h3.88l.61-1.85-3.15-3.14a2.17,2.17,0,0,0-3.09,0L5.36,32.87a2.18,2.18,0,0,0,0,3.09l3.09,3.09H9.8L11,35.4l1.2,3.65h3.89L13,41.3l1.1,3.36L25.57,56.17A2.18,2.18,0,0,0,28.66,56.17Zm7-22.59,1.2-3.64c.38,1.17.79,2.4,1.2,3.64h3.88l-3.14,2.25c.4,1.2.83,2.51,1.2,3.65-1-.73-2.08-1.49-3.14-2.25L33.7,39.48l1.2-3.65-3.15-2.25Zm-18.8-5.41h3.88l1.2-3.64c.39,1.17.79,2.4,1.2,3.64H27l-3.14,2.26c.39,1.2.82,2.5,1.2,3.64l-3.15-2.25-3.14,2.25L20,30.43Zm4.29,15.88H25l1.19-3.64c.39,1.17.8,2.4,1.2,3.64H31.3L28.16,46.3c.4,1.2.83,2.51,1.2,3.65-1-.73-2.08-1.49-3.14-2.25L23.08,50l1.2-3.65Z",
    transform: "translate(-4.72 -12.62)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.23,66.25h2.56a2.68,2.68,0,0,1,1.91.67,1.81,1.81,0,0,1,.5,1.3v0a1.91,1.91,0,0,1-1.36,1.9,2,2,0,0,1,1.7,1.92v0c0,1.32-1.07,2.14-2.7,2.14H91.23Zm4.41,2c0-.9-.68-1.49-1.86-1.49h-2v3.17H93.7c1.17,0,1.94-.59,1.94-1.65Zm-1.89,2.2h-2V73.7h2.08c1.29,0,2.11-.61,2.11-1.62v0C96,71,95.19,70.46,93.75,70.46Z",
    transform: "translate(-4.72 -12.62)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.69,71.33v0c0-1.81,1-3,2.35-3s2.26,1.23,2.26,3v.27H98.23c.07,1.49,1,2.34,2,2.34a2.17,2.17,0,0,0,1.61-.72l.32.36a2.61,2.61,0,0,1-2,.86C98.84,74.35,97.69,73.21,97.69,71.33Zm4.06-.3c0-1.24-.64-2.31-1.72-2.31s-1.72.93-1.8,2.31Z",
    transform: "translate(-4.72 -12.62)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.93,72.9V68.84h-.74v-.48h.74v-1.8h.53v1.8h1.65v.48h-1.65v4a.85.85,0,0,0,1,1,1.78,1.78,0,0,0,.68-.15v.49a1.6,1.6,0,0,1-.76.16A1.29,1.29,0,0,1,103.93,72.9Z",
    transform: "translate(-4.72 -12.62)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M107.75,72.9V68.84H107v-.48h.74v-1.8h.53v1.8h1.65v.48h-1.65v4a.85.85,0,0,0,1,1,1.79,1.79,0,0,0,.69-.15v.49a1.66,1.66,0,0,1-.77.16A1.28,1.28,0,0,1,107.75,72.9Z",
    transform: "translate(-4.72 -12.62)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M110.85,71.33v0c0-1.81,1-3,2.34-3s2.26,1.23,2.26,3v.27h-4.06c.06,1.49,1,2.34,2,2.34a2.17,2.17,0,0,0,1.61-.72l.33.36a2.63,2.63,0,0,1-2,.86C112,74.35,110.85,73.21,110.85,71.33Zm4.05-.3c0-1.24-.64-2.31-1.72-2.31s-1.72.93-1.79,2.31Z",
    transform: "translate(-4.72 -12.62)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M116.85,68.36h.52v1.38a2.26,2.26,0,0,1,2.15-1.46v.56h0a2.18,2.18,0,0,0-2.11,2.45v2.93h-.52Z",
    transform: "translate(-4.72 -12.62)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M123.3,75.27l.27-.46a3.4,3.4,0,0,0,2,.64,1.74,1.74,0,0,0,1.9-1.9v-1a2.33,2.33,0,0,1-2,1.31,2.5,2.5,0,0,1-2.32-2.77v0a2.52,2.52,0,0,1,2.32-2.78,2.32,2.32,0,0,1,2,1.29V68.36H128v5.2a2.38,2.38,0,0,1-.63,1.73,2.44,2.44,0,0,1-1.81.66A4,4,0,0,1,123.3,75.27Zm4.16-4.22v0a2.13,2.13,0,0,0-2-2.28c-1,0-1.83.83-1.83,2.28v0c0,1.42.84,2.29,1.83,2.29A2.13,2.13,0,0,0,127.46,71.05Z",
    transform: "translate(-4.72 -12.62)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M129.4,71.32v0c0-1.7,1.06-3,2.51-3s2.52,1.32,2.52,3v0a2.77,2.77,0,0,1-2.53,3C130.45,74.35,129.4,73,129.4,71.32Zm4.48,0v0c0-1.46-.89-2.54-2-2.54s-2,1.09-2,2.53v0c0,1.45.87,2.54,2,2.54S133.88,72.75,133.88,71.32Z",
    transform: "translate(-4.72 -12.62)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M135.08,68.36h.59l1.83,5.18,1.86-5.18h.57l-2.2,5.91h-.45Z",
    transform: "translate(-4.72 -12.62)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M140.59,71.33v0c0-1.81,1-3,2.34-3s2.26,1.23,2.26,3v.27h-4.06a2.06,2.06,0,0,0,3.6,1.62l.33.36a2.63,2.63,0,0,1-2,.86C141.73,74.35,140.59,73.21,140.59,71.33Zm4-.3c0-1.24-.64-2.31-1.72-2.31s-1.71.93-1.79,2.31Z",
    transform: "translate(-4.72 -12.62)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M146.59,68.36h.52v1.38a2.26,2.26,0,0,1,2.16-1.46v.56h-.05a2.18,2.18,0,0,0-2.11,2.45v2.93h-.52Z",
    transform: "translate(-4.72 -12.62)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M150.46,68.36H151v1a2,2,0,0,1,3.76,1.06v3.79h-.52V70.58c0-1.19-.55-1.87-1.53-1.87A1.77,1.77,0,0,0,151,70.63v3.59h-.52Z",
    transform: "translate(-4.72 -12.62)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M156.45,68.36H157v1a1.83,1.83,0,0,1,1.68-1.12,1.75,1.75,0,0,1,1.67,1.16,2,2,0,0,1,1.82-1.16c1.16,0,1.9.83,1.9,2.22v3.77h-.52V70.58c0-1.22-.54-1.87-1.44-1.87s-1.57.71-1.57,1.91v3.6H160V70.55c0-1.19-.54-1.84-1.42-1.84A1.75,1.75,0,0,0,157,70.63v3.59h-.51Z",
    transform: "translate(-4.72 -12.62)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M165.43,71.33v0c0-1.81,1-3,2.34-3s2.26,1.23,2.26,3v.27H166c.07,1.49,1,2.34,2,2.34a2.17,2.17,0,0,0,1.61-.72l.32.36a2.59,2.59,0,0,1-2,.86C166.57,74.35,165.43,73.21,165.43,71.33Zm4-.3c0-1.24-.64-2.31-1.72-2.31S166,69.65,166,71Z",
    transform: "translate(-4.72 -12.62)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.43,68.36H172v1a1.91,1.91,0,0,1,1.79-1.14,1.94,1.94,0,0,1,2,2.2v3.79h-.53V70.58c0-1.19-.55-1.87-1.53-1.87a1.77,1.77,0,0,0-1.7,1.92v3.59h-.52Z",
    transform: "translate(-4.72 -12.62)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M177.65,72.9V68.84h-.74v-.48h.74v-1.8h.53v1.8h1.65v.48h-1.65v4a.85.85,0,0,0,1,1,1.79,1.79,0,0,0,.69-.15v.49a1.66,1.66,0,0,1-.77.16A1.28,1.28,0,0,1,177.65,72.9Z",
    transform: "translate(-4.72 -12.62)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M181.12,73.26h.73v1h-.73Z",
    transform: "translate(-4.72 -12.62)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M185.8,73.23l.37-.44a3.16,3.16,0,0,0,2.31,1,1.62,1.62,0,0,0,1.78-1.54v0c0-.75-.35-1.24-1.89-1.79-1.72-.62-2.26-1.25-2.26-2.29v0a2.11,2.11,0,0,1,2.28-2,3.29,3.29,0,0,1,2.29.87l-.35.46a2.8,2.8,0,0,0-2-.8,1.53,1.53,0,0,0-1.7,1.45v0c0,.77.37,1.25,2,1.81s2.19,1.29,2.19,2.28v0a2.17,2.17,0,0,1-2.35,2.1A3.72,3.72,0,0,1,185.8,73.23Z",
    transform: "translate(-4.72 -12.62)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M192.56,72.9V68.84h-.74v-.48h.74v-1.8h.53v1.8h1.65v.48h-1.65v4a.85.85,0,0,0,1,1,1.78,1.78,0,0,0,.68-.15v.49a1.6,1.6,0,0,1-.76.16A1.29,1.29,0,0,1,192.56,72.9Z",
    transform: "translate(-4.72 -12.62)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.14,68.36h.52v1.38a2.26,2.26,0,0,1,2.16-1.46v.56h0a2.18,2.18,0,0,0-2.11,2.45v2.93h-.52Z",
    transform: "translate(-4.72 -12.62)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M199.42,71.32v0a2.77,2.77,0,0,1,2.52-3c1.46,0,2.51,1.32,2.51,3v0a2.77,2.77,0,0,1-2.53,3C200.48,74.35,199.42,73,199.42,71.32Zm4.48,0v0c0-1.46-.89-2.54-2-2.54S200,69.82,200,71.26v0c0,1.45.88,2.54,2,2.54S203.9,72.75,203.9,71.32Z",
    transform: "translate(-4.72 -12.62)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M205.9,68.36h.51v1a2,2,0,0,1,3.77,1.06v3.79h-.53V70.58c0-1.19-.55-1.87-1.53-1.87a1.77,1.77,0,0,0-1.71,1.92v3.59h-.51Z",
    transform: "translate(-4.72 -12.62)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M211.79,75.27l.27-.46a3.37,3.37,0,0,0,1.95.64,1.74,1.74,0,0,0,1.9-1.9v-1a2.31,2.31,0,0,1-2,1.31,2.5,2.5,0,0,1-2.33-2.77v0a2.53,2.53,0,0,1,2.33-2.78,2.3,2.3,0,0,1,2,1.29V68.36h.53v5.2a2.42,2.42,0,0,1-.63,1.73A2.48,2.48,0,0,1,214,76,4,4,0,0,1,211.79,75.27Zm4.15-4.22v0a2.13,2.13,0,0,0-2-2.28c-1,0-1.83.83-1.83,2.28v0c0,1.42.85,2.29,1.83,2.29A2.13,2.13,0,0,0,215.94,71.05Z",
    transform: "translate(-4.72 -12.62)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M217.88,71.33v0c0-1.81,1-3,2.35-3s2.26,1.23,2.26,3v.27h-4.07c.07,1.49,1,2.34,2,2.34a2.17,2.17,0,0,0,1.61-.72l.32.36a2.61,2.61,0,0,1-2,.86C219,74.35,217.88,73.21,217.88,71.33Zm4.06-.3c-.05-1.24-.64-2.31-1.72-2.31s-1.72.93-1.8,2.31Z",
    transform: "translate(-4.72 -12.62)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M223.89,68.36h.51v1.38a2.26,2.26,0,0,1,2.16-1.46v.56h0a2.18,2.18,0,0,0-2.12,2.45v2.93h-.51Z",
    transform: "translate(-4.72 -12.62)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M230.12,71.34v-.09c0-1.93,1.15-3,2.34-3a2.27,2.27,0,0,1,2,1.34V66H235v8.22h-.53V73a2.28,2.28,0,0,1-2,1.38C231.27,74.35,230.12,73.28,230.12,71.34Zm4.38,0v-.11a2.25,2.25,0,0,0-2-2.5c-1,0-1.85.89-1.85,2.51v.08c0,1.59.85,2.53,1.85,2.53A2.26,2.26,0,0,0,234.5,71.34Z",
    transform: "translate(-4.72 -12.62)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.44,71.33v0c0-1.81,1-3,2.34-3s2.26,1.23,2.26,3v.27H237c.07,1.49,1,2.34,2,2.34a2.17,2.17,0,0,0,1.61-.72l.32.36a2.59,2.59,0,0,1-2,.86C237.58,74.35,236.44,73.21,236.44,71.33Zm4.05-.3c-.05-1.24-.64-2.31-1.72-2.31s-1.72.93-1.8,2.31Z",
    transform: "translate(-4.72 -12.62)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M242.44,68.36H243v1a1.8,1.8,0,0,1,1.67-1.12,1.75,1.75,0,0,1,1.67,1.16,2,2,0,0,1,1.82-1.16c1.16,0,1.9.83,1.9,2.22v3.77h-.52V70.58c0-1.22-.54-1.87-1.43-1.87a1.69,1.69,0,0,0-1.58,1.91v3.6H246V70.55c0-1.19-.54-1.84-1.43-1.84A1.75,1.75,0,0,0,243,70.63v3.59h-.52Z",
    transform: "translate(-4.72 -12.62)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M251.42,71.32v0c0-1.7,1.06-3,2.51-3s2.52,1.32,2.52,3v0a2.77,2.77,0,0,1-2.53,3C252.47,74.35,251.42,73,251.42,71.32Zm4.48,0v0c0-1.46-.89-2.54-2-2.54S252,69.82,252,71.26v0c0,1.45.87,2.54,2,2.54S255.9,72.75,255.9,71.32Z",
    transform: "translate(-4.72 -12.62)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M257.56,71.34v-.07c0-1.79,1.13-3,2.54-3a2.44,2.44,0,0,1,1.79.81l-.33.41a2.07,2.07,0,0,0-1.49-.72c-1.06,0-2,1-2,2.54v.06c0,1.56.94,2.52,2,2.52a2.09,2.09,0,0,0,1.47-.73l.33.35a2.34,2.34,0,0,1-1.83.88C258.66,74.35,257.56,73.13,257.56,71.34Z",
    transform: "translate(-4.72 -12.62)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M263.21,68.36h.52v1.38a2.26,2.26,0,0,1,2.16-1.46v.56h-.05a2.18,2.18,0,0,0-2.11,2.45v2.93h-.52Z",
    transform: "translate(-4.72 -12.62)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M266.41,72.51v0a1.93,1.93,0,0,1,2.19-1.89,5.19,5.19,0,0,1,1.6.24v-.43a1.47,1.47,0,0,0-1.62-1.61,3.12,3.12,0,0,0-1.54.42l-.2-.47a4,4,0,0,1,1.77-.45,1.91,1.91,0,0,1,2.1,2.08v3.86h-.51v-.93a2.1,2.1,0,0,1-1.86,1.06A1.85,1.85,0,0,1,266.41,72.51Zm3.8-.36v-.84a5.13,5.13,0,0,0-1.62-.26c-1,0-1.63.57-1.63,1.4v0a1.35,1.35,0,0,0,1.43,1.37A1.75,1.75,0,0,0,270.21,72.15Z",
    transform: "translate(-4.72 -12.62)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M272.07,71.34v-.07c0-1.79,1.13-3,2.54-3a2.42,2.42,0,0,1,1.79.81l-.33.41a2,2,0,0,0-1.49-.72c-1.06,0-2,1-2,2.54v.06c0,1.56.94,2.52,2,2.52a2.09,2.09,0,0,0,1.47-.73l.34.35a2.38,2.38,0,0,1-1.83.88C273.17,74.35,272.07,73.13,272.07,71.34Z",
    transform: "translate(-4.72 -12.62)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M281.47,68.36H282l-2.1,6C279.5,75.55,279,76,278.24,76a2,2,0,0,1-.95-.23l.18-.48a1.51,1.51,0,0,0,.8.21c.5,0,.83-.3,1.19-1.24l-2.32-5.86h.59l2,5.19Z",
    transform: "translate(-4.72 -12.62)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M282.44,73.26h.73v1h-.73Z",
    transform: "translate(-4.72 -12.62)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPpsLogo);
export default __webpack_public_path__ + "static/media/pps-logo.e9b6efe9c10f21036ff3237bb0b2f58d.svg";
export { ForwardRef as ReactComponent };